import React from "react";
import { Link } from "react-router-dom";
import Logo from "assets/images/logo-dark.png";
import Contact from "components/sections/Contact";

const Footer = () => {
  return (
    <>
      <Contact />
      <footer className="footer-section">
        <div className="container hidden">
          <div className="footer-extended">
            <div className="row">
              {/* <div className="col-lg-3 col-md-3 footer-nav">
                <h5>Emerging Technologies</h5>
                <ul>
                  <li>
                    <Link to="#">Data Science & AI</Link>
                  </li>
                  <li>
                    <Link to="#">Internet of Things</Link>
                  </li>
                  <li>
                    <Link to="#">Robotic Process Automation</Link>
                  </li>
                </ul>
              </div> */}
              <div className="col-lg-3 col-md-3 footer-nav">
                <h5>Services</h5>
                <ul>
                  <li>
                    <Link to="#">Customer Software Development</Link>
                  </li>
                  <li>
                    <Link to="#">Web Application</Link>
                  </li>
                  <li>
                    <Link to="#">Mobile Application</Link>
                  </li>
                  <li>
                    <Link to="#">UI/UX</Link>
                  </li>
                  <li>
                    <Link to="#">QA & Testing</Link>
                  </li>
                  <li>
                    <Link to="#">DevOps</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3 footer-nav">
                <h5>Industries</h5>
                <ul>
                  <li>
                    <Link to="#">Education</Link>
                  </li>
                  <li>
                    <Link to="#">Healthcare</Link>
                  </li>
                  <li>
                    <Link to="#">eCommerce</Link>
                  </li>
                  <li>
                    <Link to="#">Fintech</Link>
                  </li>
                  <li>
                    <Link to="#">Information</Link>
                  </li>
                  <li>
                    <Link to="#">Travel</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3 footer-nav">
                <h5>Find More</h5>
                <ul>
                  <li>
                    <Link to="#">About Us</Link>
                  </li>
                  <li>
                    <Link to="#">Engagement Models</Link>
                  </li>
                  <li>
                    <Link to="#">Blogs</Link>
                  </li>
                  <li>
                    <Link to="#">Careers</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-about-us">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-md-4">
                <div className="img-wrap max-w-[250px] mx-auto">
                  <img src={Logo} height="70px" alt="not-found" />
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <div className="about-text">
                  <h3>OUR VISION</h3>
                  <p>Building the next generation of intelligent products.</p>
                  <p>
                    {" "}
                    At Transcend, we're an AI-first studio that turns ideas into smart mobile and web applications. We blend
                    great engineering with conversational AI, agents, and copilots — shipping products that learn, adapt, and
                    delight your users from MVP to scale.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <p className="copyright-text m-0 float-left">© Copyright {new Date().getFullYear()} Transcend. All right reserved</p>
            <a href="#scrolltop" className="btn-scroll-top float-right">
              Back to Top
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
